<template>
    <div class="emptyPlaceholder">
        <img class="imgInfo" src="@/assets/empty-icon-green.svg" />
        <img class="imgWarning" src="@/assets/empty-icon-red.svg" />

        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "empty-placeholder",
};
</script>

<style lang="scss" scoped>
.emptyPlaceholder {
    padding: 20px 15px;
    margin-bottom: 20px;
    border-radius: 12px;
    position: relative;
    margin-top: 30px;
    background: #15f29f;
    color: #267962;
    line-height: 24px;
    font-size: 14px;
    .imgInfo,
    .imgWarning {
        position: absolute;
        right: 11px;
        top: -16px;
        filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.5));
    }
    .imgWarning {
        display: none;
    }
    &.warning {
        background: #d08585;
        color: white;
        .imgWarning {
            display: block;
        }
        .imgInfo {
            display: none;
        }
    }

    &.info2 {
        background: #baf8e1;

        .imgWarning {
            display: none;
        }
        .imgInfo {
            display: block;
        }
    }

    &.mt30 {
        margin-top: 30px;
    }

    &.mt20 {
        margin-top: 20px;
    }

    &.mt10 {
        margin-top: 10px;
    }

    &.mb10 {
        margin-bottom: 10px;
    }
    &.mb0 {
        margin-bottom: 0px;
    }
}
</style>
